import React from 'react';

import zolaLogo from '../../assets/images/logos/zola-logo-horizontal-black.svg';

const FooterLogo = (): JSX.Element => {
  return <img src={zolaLogo} alt="Zola logo" className="zola-logo-img" />;
};

export default FooterLogo;
